import React, { useEffect, useRef, useState } from 'react';
import styles from "./style.module.scss";
import { Skeleton } from 'antd';
import {
    useGetActiveSellersQuery,
    useGetBestSellerAuthorsQuery,
    useGetTopProductsListQuery
} from '~/features/pages/api';

const MAIN_SITE_URL = "https://soff.uz";

const Bests = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.2 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    const queryOptions = {
        skip: !isVisible,
    };

    const { data: sellers, isLoading: sellersLoading } = useGetActiveSellersQuery(
        { filter_by: "week" },
        queryOptions
    );

    const { data: authors, isLoading: authorsLoading } = useGetBestSellerAuthorsQuery(
        { filter_by: "week" },
        queryOptions
    );

    const { data: products, isLoading: productsLoading } = useGetTopProductsListQuery(
        { filter_by: "week" },
        queryOptions
    );

    const isLoading =
        sellersLoading || authorsLoading || productsLoading;

    return (
        <div ref={sectionRef} id='bests' className={styles.bestsWrapper}>
            <div className={styles.titleWrapper}>
                <img src="/static/img/HomePage/icon.svg" alt="badge" className={styles.badge} />
                <h2>Haftaning eng yaxshilari</h2>
            </div>

            {isLoading ? (
                <div className={styles.grid}>
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className={styles.column}>
                            <Skeleton.Input active size="small" style={{ width: "100%", marginBottom: 20 }} />

                            {[...Array(5)].map((_, idx) => (
                                <div key={idx} className={styles.item} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Skeleton.Avatar active size={60} shape="circle" />
                                    <Skeleton title={false} active paragraph={{ rows: 2, width: ["100%", "100%"] }} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            ) : (
                <div className={styles.grid}>
                    {/* Eng faol sotuvchilar */}
                    <div className={styles.column}>
                        <h3 className={styles.columnTitle}>Eng faol sotuvchilar</h3>
                        {sellers?.map((item, idx) => (
                            <a
                                key={item.id || idx}
                                href={`${MAIN_SITE_URL}/seller/${item?.id}?tab=about`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.link}
                            >
                                <div className={styles.item}>
                                    <img
                                        src={item.image || "/static/img/ozodbek.png"}
                                        alt={item.first_name}
                                        className={styles.avatar}
                                    />
                                    <div>
                                        <p className={`${styles.name} p-0`}>
                                            {item.first_name} {item.last_name}
                                        </p>
                                        <p className={styles.infoGreen}>
                                            {item.products_count} mahsulot yuklangan
                                        </p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>

                    {/* Bestseller mualliflari */}
                    <div className={styles.column}>
                        <h3 className={styles.columnTitle}>Bestseller mualliflari</h3>
                        {authors?.map((item, idx) => (
                            <a
                                key={item.id || idx}
                                href={`${MAIN_SITE_URL}/seller/${item?.id}?tab=about`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.link}
                            >
                                <div className={styles.item}>
                                    <img
                                        src={item.image || "/static/img/ozodbek.png"}
                                        alt={item.first_name}
                                        className={styles.avatar}
                                    />
                                    <div>
                                        <p className={styles.name}>
                                            {item.first_name} {item.last_name}
                                        </p>
                                        <p className={styles.info}>
                                            {item.order_count} ta sotuv{" "}
                                            <span className={styles.infoGreen}>
                                                {item.total_amount.toLocaleString()} so’m
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>

                    {/* Top mahsulotlar */}
                    <div className={styles.column}>
                        <h3 className={styles.columnTitle}>Top mahsulotlar</h3>
                        {products?.map((item, idx) => (
                            <a
                                key={item.id || idx}
                                href={`${MAIN_SITE_URL}/product/${item?.slug}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.link}
                            >
                                <div className={styles.item}>
                                    <img
                                        src={item.poster || "/static/img/ozodbek.png"}
                                        alt={item.title}
                                        className={styles.avatar}
                                    />
                                    <div>
                                        <p className={styles.name}>{item.title}</p>
                                        <p className={styles.info}>
                                            {item.view_count} ta ko‘rilgan,{" "}
                                            <span className={styles.infoGreen}>
                                                {item.sold_count} ta sotilgan
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            )
            }
        </div >
    );
};

export default Bests;
